import { removeTeamMember } from "api/team";
import { useGlobalToast } from "components/GlobalToastProvider";
import { useMutation } from "react-query";

export const useRemoveTeamMember = (options = {}) => {
  const { onError = () => {}, ...otherOptions } = options;
  const { showToast } = useGlobalToast();

  const { mutate, ...rest } = useMutation(
    ({ teamId, userId }) => removeTeamMember(teamId, userId),
    {
      onError: (_, variables, context) => {
        showToast({
          message: "Whoops! Something went wrong",
          errorState: true,
          retryHandler: () => mutate(variables, context),
        });
        onError();
      },
      ...otherOptions,
    }
  );

  return {
    removeTeamMemberMutation: mutate,
    ...rest,
  };
};
